import { FileSearchOutlined } from "@ant-design/icons";
import { Button, Dropdown } from "antd";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { IoIosMore } from "react-icons/io";
import { IoChevronDown, IoChevronUp, IoClose } from "react-icons/io5";
import { RxDrawingPinFilled } from "react-icons/rx";
import { TbArrowBigUpLines } from "react-icons/tb";
import apiFactory from "../../../api";
import ImageDisplay from "../../../components/chat/ImageDisplay";
import { PreviewFile } from "../../../components/chat/PreviewFile";
import { MESSAGE_STATUS } from "../../../config/Constant";
import { useMenuContext } from "../../../context/MenuContext";
import { useInfoUser } from "../../../store/UserStore";
import {
  openNotificationError,
  pinnedMessage,
  truncateText,
} from "../../../utils/Utils";
import "./style.scss";

const PinnedMessage = ({
  data,
  jumpToMessage,
  selectedConversation,
  heightHeader,
  showAllPin,
  setShowAllPin,
}) => {
  const { isMessageSearch } = useMenuContext();
  const [token] = useState(Cookies.get("access_token"));
  const [pinnedData, setPinnedData] = useState(data || []);
  const [isLoadingOnPin, setIsLoadingOnPin] = useState(false);
  const { languageMap } = useInfoUser();

  const onPromote = async (pinnedMessage) => {
    setIsLoadingOnPin(true);

    const updatedData = [...pinnedData];
    const index = updatedData.findIndex(
      (item) => item?.messageDetail?.messageId === pinnedMessage?.messageId,
    );

    if (index > -1) {
      const [promoted] = updatedData.splice(index, 1);
      promoted._animated = true;
      promoted.highlighted = true;

      updatedData.unshift(promoted);
      setPinnedData(updatedData);

      setTimeout(() => {
        promoted._animated = false;
        promoted.highlighted = false;
        setPinnedData([...updatedData]);
      }, 200);
    }

    try {
      const result = await apiFactory.messageApi.promotePinnedMessage({
        conversationId: pinnedMessage?.conversationId,
        messageId: pinnedMessage?.messageId,
      });
      if (result?.status === 200) {
        // setShowAllPin(false);
      } else {
        openNotificationError(
          "Failed to promote the message. Please try again.",
        );
      }
    } catch (error) {
      console.error("Promote failed: ", error);
      openNotificationError("An error occurred while promoting the message.");
    } finally {
      setIsLoadingOnPin(false);
    }
  };

  const unPinMessage = async (message) => {
    pinnedMessage(message, setIsLoadingOnPin);
    if (pinnedData?.length === 2) {
      setShowAllPin(false);
    }
  };

  useEffect(() => {
    setPinnedData(data);
    setIsLoadingOnPin(false);
  }, [data]);

  if (!pinnedData || pinnedData?.length === 0) return null;

  return (
    <div
      className={` absolute left-[0] mt-[-10px] right-[0] ${showAllPin && pinnedData?.length > 1 && " z-[100] bg-[#0000008c] h-[100vh] transition-all duration-200 ease"} `}
      style={{
        top: `${heightHeader + 25}px`,
      }}
      onClick={() => setShowAllPin(!showAllPin)}
    >
      {!isMessageSearch && (
        <div
          className={`${showAllPin && pinnedData?.length > 1 && "overlay"} absolute top-[5px] left-[4px] right-[4px] z-[100] bg-white rounded-md shadow space-y-2 overflow-hidden`}
        >
          {showAllPin && pinnedData?.length > 1 && (
            <div className="flex items-center justify-between bg-[#ebecf0] p-1 px-3">
              <div className="font-medium text-sm">
                Pinbroad ({pinnedData?.length})
              </div>
              <div className="flex justify-end">
                <button
                  onClick={() => setShowAllPin(!showAllPin)}
                  className="flex items-center gap-1 text-xs text-blue-600 transition "
                >
                  {showAllPin ? (
                    <>
                      {languageMap?.["conversation.message.showLess"] ??
                        "Show less"}
                      <IoChevronUp size={15} />
                    </>
                  ) : (
                    <>
                      {languageMap?.["conversation.message.seeAll"] ??
                        "See all"}
                      ({pinnedData?.length})
                      <IoChevronDown size={15} />
                    </>
                  )}
                </button>
              </div>
            </div>
          )}

          <PinnedMessageItem
            item={pinnedData[0]}
            index={0}
            isFirst={true}
            showAllPin={showAllPin}
            setShowAllPin={setShowAllPin}
            onPromote={onPromote}
            unPinMessage={unPinMessage}
            isLoadingOnPin={isLoadingOnPin}
            jumpToMessage={jumpToMessage}
            selectedConversation={selectedConversation}
            token={token}
            pinnedData={pinnedData}
            languageMap={languageMap}
          />

          {showAllPin && pinnedData?.length > 1 && (
            <>
              {pinnedData?.slice(1).map((item, index) => (
                <PinnedMessageItem
                  key={index}
                  item={item}
                  index={index + 1}
                  isFirst={false}
                  showAllPin={showAllPin}
                  setShowAllPin={setShowAllPin}
                  onPromote={onPromote}
                  unPinMessage={unPinMessage}
                  isLoadingOnPin={isLoadingOnPin}
                  jumpToMessage={jumpToMessage}
                  selectedConversation={selectedConversation}
                  token={token}
                  pinnedData={pinnedData}
                  languageMap={languageMap}
                />
              ))}
            </>
          )}
        </div>
      )}
    </div>
  );
};

const PinnedMessageItem = ({
  item,
  index,
  isFirst,
  showAllPin,
  setShowAllPin,
  onPromote,
  unPinMessage,
  isLoadingOnPin,
  jumpToMessage,
  selectedConversation,
  token,
  pinnedData,
  languageMap,
}) => {
  const onMenuClick = (keyDom) => {
    const { key } = keyDom;

    switch (key) {
      case "unpin":
        unPinMessage(item?.messageDetail);
        break;
      case "promote":
        onPromote(item?.messageDetail);
        break;
      case "jump":
        setShowAllPin(false);
        jumpToMessage(item?.messageDetail);
        break;
      default:
        console.log("Không có action");
    }
  };

  const defaultItems = [
    {
      key: "unpin",
      icon: <IoClose size={16} />,
      label: languageMap?.["conversation.message.unpin"] ?? "Unpin",
    },
    {
      key: "jump",
      label: languageMap?.["conversation.message.jump"] ?? "Jump to message",
      icon: <FileSearchOutlined />,
    },
  ];

  const extraItems = () => {
    if (!isFirst) {
      return [
        {
          key: "promote",
          icon: <TbArrowBigUpLines size={16} />,
          label: languageMap?.["conversation.message.pinToTop"] ?? "Pin to top",
        },
      ];
    }
    return [];
  };

  const renderPinnedContent = () => {
    switch (item?.messageDetail?.contentType) {
      case MESSAGE_STATUS.FILE:
        return (
          <PreviewFile
            isPinned={true}
            requestUuid={item?.messageDetail?.messageId}
            content={item?.messageDetail?.content}
            file={item?.messageDetail?.files?.[0]}
            contentType={item?.messageDetail?.contentType}
            percentProgress={0}
            totalVolume={item?.messageDetail?.totalVolume}
          />
        );
      case MESSAGE_STATUS.IMAGE:
        return (
          <div className="flex items-center">
            <ImageDisplay
              resourceId={item?.messageDetail?.photos?.[0]?.resourceId}
              classNameCss={
                "max-w-full max-h-40 rounded-md mb-1 mr-[4px] pinned-img"
              }
            />
            <p>
              {truncateText(item?.messageDetail?.content, 150) || "[Image]"}
            </p>
          </div>
        );
      default:
        if (
          item?.messageDetail?.contentType === MESSAGE_STATUS.TEXT &&
          item?.messageDetail?.previewLink?.image
        ) {
          return (
            <div className="flex items-center">
              <img
                src={item?.messageDetail?.previewLink?.image}
                alt="preview"
                className="max-w-[40px] max-h-40 rounded-md mb-1 mr-[4px] pinned-img"
              />
              <p>
                {truncateText(item?.messageDetail?.content, 150) || "Image"}
              </p>
            </div>
          );
        }
        return truncateText(item?.messageDetail?.content, 150) || "...";
    }
  };

  return (
    <div
      key={index}
      className={`flex items-center h-[50px] px-3 !mt-0 ${showAllPin && pinnedData?.length > 1 && "hover:bg-[#f2f6ff]"} border-b transition relative`}
    >
      <RxDrawingPinFilled className="text-blue-600 shrink-0 m-auto" size={18} />

      <div
        onClick={(e) => {
          e.stopPropagation();
          setShowAllPin(false);
          jumpToMessage(item?.messageDetail);
        }}
        className="ml-3 cursor-pointer flex-1 overflow-hidden"
      >
        <div className=" font-medium text-[12px] text-gray-700 truncate">
          <span className="">{item?.pinnedBy?.name}</span>
          <span className="ml-[2px] text-gray-700">
            {languageMap?.["conversation.message.pinned"] ?? "Pinned:"}
          </span>
        </div>

        <div className=" text-[12px] text-gray-600 truncate w-[70%]">
          {renderPinnedContent()}
        </div>
      </div>

      <div className="flex items-center gap-1 ml-2 shrink-0">
        {showAllPin || !isFirst || pinnedData?.length === 1 ? (
          <div onClick={(e) => e.stopPropagation()}>
            <Dropdown
              menu={{
                items: [...defaultItems, ...extraItems()],
                onClick: onMenuClick,
              }}
              trigger={["click"]}
              placement="leftTop"
            >
              <Button
                type="text"
                size="small"
                icon={<IoIosMore />}
                className="!bg-white hover:!bg-white active:!bg-white !shadow rounded-full border border-gray"
              />
            </Dropdown>
          </div>
        ) : (
          <div className="flex justify-end absolute right-[20px]">
            <button
              onClick={() => setShowAllPin(!showAllPin)}
              className="
                flex items-center gap-1 text-xs text-blue-500 transition 
                border border-gray-300 px-2 py-1 
                hover:bg-[#f2f6ff]
              "
            >
              + {pinnedData?.length} pin
              <IoChevronDown size={15} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export { PinnedMessage, PinnedMessageItem };
